import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Map pricing tier name -> backend package_id
export const tierToPackageId = (tierName) => tierName.toLowerCase();

export async function startCheckout(tierName) {
  const packageId = tierToPackageId(tierName);
  const originUrl = window.location.origin;
  try {
    const res = await axios.post(`${API}/payments/checkout`, {
      package_id: packageId,
      origin_url: originUrl,
    });
    if (res.data?.checkout_url) {
      window.location.href = res.data.checkout_url;
    } else {
      alert('Could not start checkout. Please try again in a moment.');
    }
  } catch (e) {
    console.error('Checkout error', e);
    alert(e?.response?.data?.detail || 'Something went wrong starting checkout. Please try again.');
  }
}
